import React, { useState } from 'react';
import QrReader from 'react-qr-reader';
import { getUserById } from '../api/user';
import { useQuery } from 'react-query';
import { useLocation } from 'wouter';
import MemberNotFound from './MemberNotFound';
import MemberFound from './MemberFound';
import Modal from './Modal';
import Loader from './Loader';
import Button from './Button';

interface MemberScannerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: (open: boolean) => void;
}

const MemberScanner: React.FC<MemberScannerProps> = ({ open, setOpen }) => {
  const [memberId, setMemberId] = useState(null);
  const [location, setLocation] = useLocation();

  const handleScan = (data: any) => {
    if (data && !memberId) {
      setMemberId(data);
    }
  };

  const handleError = (err: any) => {
    console.error(err);
  };

  const closeScanner = () => {
    setOpen(false);
    setMemberId(null);
  };

  const userQuery = useQuery<any, any>(
    ['getUserById', memberId],
    ({ queryKey }) => getUserById(queryKey[1]),
    {
      enabled: !!memberId,
    }
  );

  return (
    <Modal open={open} setOpen={setOpen}>
      {({ cancelButtonRef }) => (
        <>
          {userQuery.isLoading && <Loader />}

          {userQuery.data && <MemberFound user={userQuery.data} />}
          {!memberId && (
            <div>
              <h2 className="ceas-text-2xl ceas-text-center ceas-mb-5">Scan member QR code</h2>
              <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                className="ceas-rounded"
              />
            </div>
          )}

          {userQuery.error?.response?.status === 404 && (
            <MemberNotFound onClick={() => setMemberId(null)} />
          )}
          <div className="ceas-mt-5 sm:ceas-mt-4 ceas-flex ceas-justify-between">            
            <Button onClick={closeScanner} ref={cancelButtonRef}>
              Cancel
            </Button>
            {userQuery.data && (
              <Button theme="primary" onClick={() => setLocation(`/transactions/?member_id=${userQuery.data.id}`)}>
                Continue
              </Button>
            )}
          </div>
        </>
      )}
    </Modal>
  );
};

export default MemberScanner;
